import { render } from "./TextDetail.vue?vue&type=template&id=f5caacca&scoped=true"
import script from "./TextDetail.vue?vue&type=script&lang=js"
export * from "./TextDetail.vue?vue&type=script&lang=js"

import "./TextDetail.vue?vue&type=style&index=0&id=f5caacca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5caacca"]])

export default __exports__